import React, { useState } from 'react';
import './Tabs.css';

interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  forceTab?: string | null;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, defaultTab, forceTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  React.useEffect(() => {
    if (forceTab && tabs.some((t) => t.id === forceTab)) {
      setActiveTab(forceTab);
    }
  }, [forceTab, tabs]);

  const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content;

  return (
    <div className="tabs">
      <div className="tabs__header">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tabs__tab ${activeTab === tab.id ? 'tabs__tab--active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="tabs__content">{activeTabContent}</div>
    </div>
  );
};
